/**
 * @function sortInstancesByInstanceTypeAndUpdatedDate
 * @description Sorts instances by instance type and updated on
 * @param {Array} instances - Array of instances
 * @returns {Array} - Sorted array of instances
 * @example
 */
export function sortInstancesByInstanceTypeAndUpdatedDate(instances) {
    return instances.sort((a, b) => {
        if (a.instanceType === b.instanceType) {
            // date is static to make most recent first
            // as updated on is empty string if never updated / new instance
            const aUpdatedDate = a.updatedDate ? new Date(a.updatedDate) : new Date("1970-01-01T00:00:00.000Z");
            const bUpdatedDate = b.updatedDate ? new Date(b.updatedDate) : new Date("1970-01-01T00:00:00.000Z");
            if (aUpdatedDate > bUpdatedDate) {
                return -1;
            }
            if (aUpdatedDate < bUpdatedDate) {
                return 1;
            }
            return 0;
        }
        // Production > Test > Development
        if (a.instanceType === "Production") {
            return -1;
        }
        if (b.instanceType === "Production") {
            return 1;
        }
        if (a.instanceType === "Test") {
            return -1;
        }
        if (b.instanceType === "Test") {
            return 1;
        }
        if (a.instanceType === "Development") {
            return -1;
        }
        if (b.instanceType === "Development") {
            return 1;
        }
        return 0;
    });
}